import { STATUS_CAMPAIGN_ENUM_ARCHIVE } from '../../../shared/constants'

export const shouldFetchActiveDates = status =>
  [STATUS_CAMPAIGN_ENUM_ARCHIVE, null].includes(status)



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientView/utils.js